import { useState, useEffect } from "react";

import "./Hero06.css";

function Hero06() {
  return (
    <div className="Hero06 section" id="Hero06">
      <div className="container">
        <div className="Hero06-box">
          <h1>Frequently Asked Questions.</h1>
          <p>And other things, that we think you should know.</p>
        </div>
      </div>
    </div>
  );
}

export default Hero06;
